import { render, staticRenderFns } from "./email.vue?vue&type=template&id=300c2ec2&scoped=true&"
var script = {}
import style0 from "./email.vue?vue&type=style&index=0&id=300c2ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300c2ec2",
  null
  
)

export default component.exports